<script setup>

import {ref} from "vue";
import {usePage} from "@inertiajs/vue3";
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import axios from 'axios';
import {route} from "ziggy-js";
import {useDesignApprovalContent} from '@/Composables/useDesignApprovalContent';

const page = usePage();
const accepted = ref(false);
const {content} = useDesignApprovalContent();

const updateAcceptedStatus = async () => {
    try {
        await axios.post(route('configurator.api.design.accept'), {
            accepted: accepted.value
        });
    } catch (error) {
        console.error('Error updating accepted status:', error);
    }
};

const goToCallBack = () => {
    if (accepted.value) {
        window.location.href = page.props.callBackUrl;
    }
};

</script>
<template>
    <p class="go-back-text">{{ content.text }}</p>
    <label class="go-back-accept flex align-items-center gap-2 mb-3 cursor-pointer">
        <Checkbox v-model="accepted" @change="updateAcceptedStatus" :binary="true" inputId="accept-design" />
        <span>{{ content.checkbox_label }}</span>
    </label>
    <Button @click="goToCallBack" :disabled="!accepted" label="Akkoord breng me terug naar de site"/>
</template>

<style scoped lang="scss">
.go-back-accept {
    min-height: 2.75rem;
}

.go-back-text {
    white-space: pre-line;
}
</style>